module.exports = __webpack_public_path__ + "img/img4.3d7b39a3.png";